import(/* webpackMode: "eager" */ "/home/ubuntu/download/695ae4cd7683ed00143500cf/one_solar_energy/src/app/not-found.tsx");
